export default {
  methods: {
    copy(value) {
      const textarea = document.createElement('textarea');
      textarea.contentEditable = true;
      textarea.readOnly = true;
      textarea.style.position = 'absolute';
      textarea.style.left = '-9999px';
      document.body.appendChild(textarea);
      textarea.value = value;
      textarea.select();
      textarea.setSelectionRange(0, 99999);
      document.execCommand('copy');
      textarea.remove();
      this.$alert.success(this.$t('profile.notifications.copied_message'));
    },
  },
};

